import { Collapse, Stack, Button, styled, useTheme, Typography } from '@mui/material';
import { ReactNode, useMemo, useState } from 'react';
import { RiArrowDropDownFill, RiArrowDropUpFill } from 'react-icons/ri';
import { useRouter } from 'next/router';
import { FeatureConfig } from 'src/layouts/dashboard/navbar/config';

interface Props {
  config: FeatureConfig;
  children: ReactNode;
}

export const NavbarAdminCollapseButton = ({ config, children }: Props) => {
  const router = useRouter();
  const isTarget: boolean = useMemo(
    () => config.configs.some((config) => config.href === router.pathname),
    [config.configs, router.pathname]
  );
  const [isOpen, setIsOpen] = useState<boolean>(isTarget);
  const handleClick = () => {
    setIsOpen((prev) => !prev);
  };
  const theme = useTheme();
  return (
    <Stack
      padding="4px"
      gap="10px"
      sx={{
        backgroundColor: isOpen
          ? theme.palette.surface.sidebarDarker
          : theme.palette.surface.sidebarDark,
        borderRadius: '4px',
      }}
    >
      <Stack
        direction="row"
        sx={{
          backgroundColor: isOpen
            ? theme.palette.surface.sidebarDarker
            : theme.palette.surface.sidebarDark,
          alignItems: 'center',
          p: '4px 16px 4px 12px',
          width: '100%',
          justifyContent: 'space-between',
          borderRadius: '4px',
          ':hover': {
            backgroundColor: isOpen
              ? theme.palette.surface.sidebarDark
              : theme.palette.surface.sidebarDarker,
          },
        }}
        onClick={handleClick}
      >
        <StyledButton>
          <Typography variant="titleS">{config.title}</Typography>
        </StyledButton>
        {isOpen ? (
          <RiArrowDropUpFill color="white" size={24} />
        ) : (
          <RiArrowDropDownFill color="white" size={24} />
        )}
      </Stack>
      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        {children}
      </Collapse>
    </Stack>
  );
};

const StyledButton = styled(Button)(({ theme }) => ({
  color: theme.palette.text.contrast,
  justifyContent: 'flex-start',
  fontWeight: 'normal',
  padding: 0,
  ':hover': {
    backgroundColor: theme.palette.surface.sidebarDarker,
  },
  // focus時に太字にする
  ':focus': {
    fontWeight: 'bold',
  },
}));
